import * as images from "@/components/images/Images";
import * as images2 from "@/components/images/Images_second";
import { ServicesDocumentsCard } from "./types";

const contentCertified = {
  title: "Experienced partner in official document translation",
  description:
    "We offer certified translations for a range of documents and digital formats",
} as const;

const cardsCertified: ServicesDocumentsCard[] = [
  {
    title: "Affidavits",
    imageUrl: images2.language_documents_card1,
    href: "/documents/affidavits",
  },
  {
    title: "Bank statements",
    imageUrl: images2.language_documents_card2,
    href: "/documents/bank-statements",
  },
  {
    title: "Birth Certificate",
    imageUrl: images2.language_documents_card3,
    href: "/documents/birth-certificate",
  },
  {
    title: "Contract",
    imageUrl: images2.language_documents_card4,
    href: "/documents/contract",
  },
  {
    title: "Diploma",
    imageUrl: images2.language_documents_card5,
    href: "/documents/diploma",
  },
  {
    title: "Financial Statement",
    imageUrl: images2.language_documents_card6,
    href: "/documents/financial-statement",
  },
  {
    title: "Marriage Certificate",
    imageUrl: images2.language_documents_card7,
    href: "/documents/marriage-certificate",
  },
  {
    title: "Passport",
    imageUrl: images2.language_documents_card8,
    href: "/documents/passport",
  },
  {
    title: "Transcript",
    imageUrl: images2.language_documents_card9,
    href: "/documents/transcript",
  },
];

const contentEnterprise = {
  title: "Our translators are experienced in your deliverables",
  description:
    "We match translators with focused expertise fit to your needs across a variety of documents, content types, and digital formats.",
} as const;

const cardsEnterprise: ServicesDocumentsCard[] = [
  {
    title: "Contract",
    imageUrl: images.Contract,
    href: "/documents/contract",
  },
  {
    title: "E-learning",
    imageUrl: images.E_learning,
    href: "/documents/e-learning",
  },
  {
    title: "Financial Report",
    imageUrl: images.Financial_Report,
    href: "/documents/financial-report",
  },
  {
    title: "Manual",
    imageUrl: images.Manual,
    href: "/documents/manual",
  },
  {
    title: "Patent",
    imageUrl: images.Patent,
    href: "/documents/patent",
  },
  {
    title: "Software",
    imageUrl: images.Software,
    href: "/documents/software",
  },
  {
    title: "Video",
    imageUrl: images.Video,
    href: "/documents/video",
  },
  {
    title: "Website",
    imageUrl: images.Website,
    href: "/documents/website",
  },
];

const contentNotarized = {
  title: "Notary translations for any document",
  description:
    "We offer notary certified translation across a range of documents for personal, legal and official use.",
} as const;

const cardsNotarized: ServicesDocumentsCard[] = [
  {
    title: "Birth certificate",
    href: "/documents/birth-certificate",
    imageUrl: images.Birth_certificate,
  },
  {
    title: "Contract",
    href: "/documents/contract",
    imageUrl: images.Contract,
  },
  {
    title: "Diploma",
    href: "/documents/diploma",
    imageUrl: images.Diploma,
  },
  {
    title: "Financial Statement",
    href: "/documents/financial-statement",
    imageUrl: images.Financial_Statement,
  },
  {
    title: "License",
    href: "/documents/license",
    imageUrl: images.License,
  },
  {
    title: "Marriage Certificate",
    href: "/documents/marriage-certificate",
    imageUrl: images.Marriage_Certificate,
  },
  {
    title: "Passport",
    href: "/documents/passport",
    imageUrl: images.Passport,
  },
  {
    title: "Patent",
    href: "/documents/patent",
    imageUrl: images.Patent,
  },
  {
    title: "Transcript",
    href: "/documents/transcript",
    imageUrl: images.Transcript,
  },
];

const contentUrgent = {
  title: "Urgent translations for any document",
  description:
    "Start your same day translation service immediately using our global network of reliable translators with expertise in a wide variety of documents.",
} as const;

const cardsUrgent: ServicesDocumentsCard[] = [
  {
    title: "Affidavit",
    href: "/documents/affidavits",
    imageUrl: images.Affidavits,
  },
  {
    title: "Birth certificate",
    href: "/documents/birth-certificate",
    imageUrl: images.Birth_certificate,
  },
  {
    title: "Contract",
    href: "/documents/contract",
    imageUrl: images.Contract,
  },
  {
    title: "Email",
    href: "/documents/email",
    imageUrl: images.Email,
  },
  {
    title: "Financial Report",
    href: "/documents/financial-report",
    imageUrl: images.Financial_Report,
  },
  {
    title: "Manual",
    href: "/documents/manual",
    imageUrl: images.Manual,
  },
  {
    title: "Marriage Certificate",
    href: "/documents/marriage-certificate",
    imageUrl: images.Marriage_Certificate,
  },
  {
    title: "Medical Records",
    href: "/documents/medical-records",
    imageUrl: images.Medical_Records,
  },
  {
    title: "Press release",
    href: "/documents/press-release",
    imageUrl: images.Press_release,
  },
];

export const servicesDocumentsMap = {
  certified: {
    content: contentCertified,
    cards: cardsCertified,
  },
  enterprise: {
    content: contentEnterprise,
    cards: cardsEnterprise,
  },
  notarized: {
    content: contentNotarized,
    cards: cardsNotarized,
  },
  urgent: {
    content: contentUrgent,
    cards: cardsUrgent,
  },
};
